import { createSelector } from 'reselect';
import { INITIAL_BOOKING_ROOT_KEY } from '../../constants';

const showFacebookLoginButton = 'showFacebookLoginButton';
const showGoogleLoginButton = 'showGoogleLoginButton';
const showAppleLoginButton = 'showAppleLoginButton';

export const showGoogleLoginButtonValue = createSelector(
    (state) => state[INITIAL_BOOKING_ROOT_KEY],
    (signinInit) => signinInit[showGoogleLoginButton] === 'True'
);

export const showFacebookLoginButtonValue = createSelector(
    (state) => state[INITIAL_BOOKING_ROOT_KEY],
    (signinInit) => signinInit[showFacebookLoginButton] === 'True'
);

export const showAppleLoginButtonValue = createSelector(
    (state) => state[INITIAL_BOOKING_ROOT_KEY],
    (signinInit) => signinInit[showAppleLoginButton] === 'True'
);
